import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { BrandLogo } from "@/components/ui/BrandLogo";

export function HomeHeader() {
  const { t } = useTranslation("home");

  return (
    <nav className="fixed top-0 right-0 left-0 z-50 border-b border-home-ink/10 bg-home-cream/85 px-5 py-3 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between">
        <Link to="/" className="flex items-center">
          <BrandLogo markClassName="h-9" />
        </Link>

        <div className="hidden items-center gap-7 font-body text-[15px] font-medium text-home-ink/70 md:flex">
          <a href="#what-it-handles" className="transition-colors hover:text-home-ink">
            {t("nav.handles")}
          </a>
          <a href="#how-it-works" className="transition-colors hover:text-home-ink">
            {t("nav.how")}
          </a>
          <a href="#pricing" className="transition-colors hover:text-home-ink">
            {t("nav.pricing")}
          </a>
          <a href="#faq" className="transition-colors hover:text-home-ink">
            {t("nav.faq")}
          </a>
        </div>

        <div className="flex items-center gap-2.5">
          <Link
            to="/login"
            search={{ pendingCode: undefined }}
            className="rounded-full px-4 py-2 font-body text-[15px] font-semibold whitespace-nowrap text-home-ink transition-colors hover:bg-home-ink/5"
          >
            {t("nav.login")}
          </Link>
          <Link
            to="/login"
            search={{ pendingCode: undefined }}
            className="rounded-full bg-home-yellow px-5 py-2.5 font-body text-[15px] font-bold whitespace-nowrap text-home-ink shadow-[0_8px_20px_-10px_rgba(33,31,28,0.35)] transition-all duration-300 ease-out hover:-translate-y-px hover:shadow-[0_12px_26px_-10px_rgba(33,31,28,0.4)]"
          >
            {t("nav.cta")}
          </Link>
        </div>
      </div>

      {/* Section links on phones, where the desktop row is hidden */}
      <div className="mx-auto mt-2 flex max-w-6xl gap-1 overflow-x-auto font-body text-[13px] font-semibold text-home-ink/65 md:hidden">
        <a href="#what-it-handles" className="shrink-0 rounded-full px-3 py-2 whitespace-nowrap">
          {t("nav.handles")}
        </a>
        <a href="#how-it-works" className="shrink-0 rounded-full px-3 py-2 whitespace-nowrap">
          {t("nav.how")}
        </a>
        <a href="#pricing" className="shrink-0 rounded-full px-3 py-2 whitespace-nowrap">
          {t("nav.pricing")}
        </a>
        <a href="#faq" className="shrink-0 rounded-full px-3 py-2 whitespace-nowrap">
          {t("nav.faq")}
        </a>
      </div>
    </nav>
  );
}
